const LuckyDeeplink = {
  FAQS: 'connectapp://link.connect.money/listing?params=dHlwZT1mYXEtY2F0ZWdvcmllcw==',
  ACCOUNT: 'connectapp://link.connect.money/account',
  NOTIFICATIONS: 'connectapp://link.connect.money/notificationCenter',
  LOGIN: 'connectapp://link.connect.money/login',
  OPEN_WEBVIEW: 'connectapp://link.connect.money/connect',
  TOPUP: 'connectapp://link.connect.money/topup',
  OCR: 'connectapp://link.connect.money/onboarding?type=connect',
};

export default LuckyDeeplink;
